import Modal from 'react-modal'
import { Container, ModalBody, ModalHeader } from './styles'
import { MdClose } from 'react-icons/md'
import { Box, Flex, Text } from '@chakra-ui/react'
import { iModalPadrao } from '../../../../interfaces'
import { GetDescricaoItemFeedback, GetNomeItemFeedback } from '../../../../Utils/Helper'

interface IModalProps extends iModalPadrao {
  children: any
  tipo: number
}

export const ModalConfigurarItem: React.FC<IModalProps> = ({ OnCloseModal, isOpen, tipo, children }) => {
  if (!isOpen) {
    return null
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={OnCloseModal}
      overlayClassName='react-modal-overlay'
      className={'react-modal-content-scroll'}
    >
      <Container>
        <ModalHeader>
          <Flex gap={'.25rem'} lineHeight={'16px'} flexDir={'column'}>
            <Text fontSize={'16px'} fontWeight={700}>{GetNomeItemFeedback(tipo)}</Text>
            <Text fontSize={'14px'} fontWeight={400}>{GetDescricaoItemFeedback(tipo)}</Text>
          </Flex>
          <Box style={{ color: 'var(--Red)' }}>
            <MdClose
              onClick={() => OnCloseModal()}
              cursor={'pointer'}
              size={18}
            />
          </Box>
        </ModalHeader>
        <ModalBody>
          {children}
        </ModalBody>
      </Container>
    </Modal>
  )
}
